import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import ArchiveIcon from "components/Icons/ArchiveIcon";
import ButtonLink from "components/ButtonLink";
import { useArchivedAthletes } from "providers/ArchivedAthletesProvider";

function ArchivedAthletesAction() {
  const { t } = useTranslation();
  const archivedAthletes = useArchivedAthletes();

  const hasArchivedAthletes = useMemo(() => archivedAthletes.length > 0, [archivedAthletes.length]);

  if (!hasArchivedAthletes) return null;

  return (
    <ThemeProvider2024>
      <ButtonLink
        aria-label={t("global.navigate_to_archived_athletes")}
        to="/settings/athlete-archive"
        variant="link"
        startIcon={<ArchiveIcon fontSize="small" />}
        size="small"
        sx={{
          "& .MuiButton-startIcon.MuiButton-iconSizeSmall": {
            marginRight: 0.5,
            marginLeft: 0,
          },
        }}
      >
        {t("global.archived_athletes_label")}
      </ButtonLink>
    </ThemeProvider2024>
  );
}

export default ArchivedAthletesAction;
